module.exports = __webpack_public_path__ + "assets/05e4d92af37b72c34e81330287d9f9be.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/drop/12/ScatterOrchHit05.mp3
 ** module id = 317
 ** module chunks = 0
 **/